"use client";

import dynamic from "next/dynamic";

// #region Libraries

export const MotionConfig = dynamic(() =>
	import("framer-motion").then((m) => m.MotionConfig)
);

// #endregion

// #region Design system atomic components

export const Container = dynamic(() =>
	import("@pamperedchef/design-system").then((m) => m.Container)
);
export type { ContainerProps } from "@pamperedchef/design-system";

export const Grid = dynamic(() =>
	import("@pamperedchef/design-system").then((m) => m.Grid)
);
export type { GridProps } from "@pamperedchef/design-system";

export const Col = dynamic(() =>
	import("@pamperedchef/design-system").then((m) => m.Col)
);
export type { ColProps } from "@pamperedchef/design-system";

export const Icon = dynamic(() =>
	import("@pamperedchef/design-system").then((m) => m.Icon)
);
export type { IconProps } from "@pamperedchef/design-system";

export const Heading = dynamic(() =>
	import("@pamperedchef/design-system").then((m) => m.Heading)
);
export type { HeadingProps } from "@pamperedchef/design-system";

export const Text = dynamic(() =>
	import("@pamperedchef/design-system").then((m) => m.Text)
);
export type { TextProps } from "@pamperedchef/design-system";
// #endregion

// #region Design system composite components

// Add composite components exports here

// #endregion

// #region Design system third party vendor components

// Add third party vendor components exports here

// #endregion
